import * as JsonPatch from "fast-json-patch";
import {HTTP} from "@/http";
import {Quiz} from "@/page/quiz/typeQuiz";
export async function save(
  path: string,
  str: string,
  obj: object,
  additionally = {}
): Promise<Quiz | void> {
  const _id = "_id" in obj ? obj._id : "";

  if (_id == "" || str == "") {
    return;
  }

  const oldObj: unknown = JSON.parse(str);
  if (typeof oldObj !== "object" || oldObj === null) {
    throw new TypeError("Предыдущее состояние должно быть JSON-объектом");
  }

  let compare = JsonPatch.compare(oldObj, obj);

  if (compare.length == 0) {
    return;
  }

  let send = {compare, ...additionally};
  return await HTTP.post(path, send);
}
